import { render, staticRenderFns } from "./ComplaintManagerInfo1.vue?vue&type=template&id=58276c77&scoped=true&"
import script from "./ComplaintManagerInfo1.vue?vue&type=script&lang=js&"
export * from "./ComplaintManagerInfo1.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintManagerInfo1.vue?vue&type=style&index=0&id=58276c77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58276c77",
  null
  
)

export default component.exports